export function AtrFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/atr-filled.svg'"></ng-include>`
    }
}